import i18n from 'i18next';
import type {FC} from 'react';
import {BrowserRouter, Navigate, Outlet, Route, Routes, useParams} from 'react-router-dom';
import UnsupportedDevice from '@/components/common/UnsupportedDevice';
import useIsMobile from '@/hooks/useIsMobile';
import PrivateRoute from '@/routes/PrivateRoute';
import ErrorBoundary from '@/views/ErrorBoundary';
import FloatingOnTopLayout from '@/views/FloatingOnTop';
import ForestMassDetail from '@/views/ForestMasses/Detail';
import ForestMassList from '@/views/ForestMasses/List';
import ForestMassUpload from '@/views/ForestMasses/Upload';
import InventoryPlotDetailView from '@/views/InventoryPlot/Detail';
import LoginView from '@/views/Login';
import NotFoundPage from '@/views/NotFoundPage';

const LangSetter: FC = () => {
  const {lang} = useParams();
  const supportedLanguages = ['en', 'es'];

  if (!lang || !supportedLanguages.includes(lang)) {
    return <NotFoundPage />;
  }

  if (i18n.resolvedLanguage !== lang) {
    i18n.changeLanguage(lang);
  }
  return <Outlet />;
};

const MobileChecker: FC = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return <Navigate to="/unsupported-device" replace />;
  }

  return <Outlet />;
};

const AppRoutes: FC = () => (
  <BrowserRouter>
    <Routes>
      <Route path="unsupported-device" element={<UnsupportedDevice />} />
      <Route path="" element={<ErrorBoundary />}>
        <Route path=":lang" element={<MobileChecker />}>
          <Route path="" element={<LangSetter />}>
            <Route index element={<Navigate to="forest-masses" />} />
            <Route path="forest-masses" element={<PrivateRoute />}>
              <Route path="" element={<FloatingOnTopLayout />}>
                <Route path="" element={<ForestMassList />} />
                <Route path=":uuid" element={<ForestMassDetail />} />
              </Route>
              <Route path="upload" element={<ForestMassUpload />} />
            </Route>
            <Route path="inventory-plots" element={<PrivateRoute />}>
              <Route path="" element={<FloatingOnTopLayout />}>
                <Route path=":uuid" element={<InventoryPlotDetailView />} />
              </Route>
            </Route>
            <Route path="login" element={<LoginView />} />
          </Route>
        </Route>
        <Route path="/" element={<Navigate to={i18n.resolvedLanguage || 'es'} replace />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  </BrowserRouter>
);

export default AppRoutes;
